<div class="d-flex flex-column bg-grey p-2 h-100 holder" *ngIf="imgLink" (click)="click.emit(null)">
  <div class="embed-responsive embed-responsive-16by9">
    <img class="w-100 h-auto embed-responsive-item" [src]="imgLink" [alt]="title + ' image'">
  </div>
  <img src="./assets/images/common/ic_youtube.webp" class="yt mb-auto" *ngIf="vidLink">
  <h4 class="text-center my-3">{{title}}</h4>
</div>
